// Convert Array to Object
export const arrayToObjKeyValue = (array) => array && array.reduce( (obj,item) => {
    obj[item.name] = item.value;
    return obj;
},{});

export const LangArrayToObjKeyValue = (array) => array && array.reduce( (obj,item) => {
    obj[item.lang] = item.text;
    return obj;
},{});

export const getLangText = (langArray, currentLangId) => {
    if (!langArray || !Array.isArray(langArray) || langArray.length === 0) {
        return '';
    }
    
    const langObj = LangArrayToObjKeyValue(langArray);
    
    if (langObj[currentLangId]) {
        return langObj[currentLangId];
    }
    
    if (langObj['en']) {
        return langObj['en'];
    }
    
    if (langObj['ar']) {
        return langObj['ar'];
    }
    
    // إذا مفيش حاجة من اللي فوق، خد أول حاجة متاحة
    const availableKeys = Object.keys(langObj);
    if (availableKeys.length > 0) {
        return langObj[availableKeys[0]];
    }
    
    return '';
};



//////////////
export const tenant = () => JSON.parse( localStorage.getItem('tenant'));
export const languagesCode =  ()=> tenant().languages?.map((language) =>  language.langCode )
export const generlSettings = () => tenant()?.setting?.generalSettings;
export const  AppSettings =  () => tenant()?.setting?.appSetting;
export const user = () => JSON.parse( localStorage?.getItem('user'));
export const appStorageKey = (key) => `${process.env.REACT_APP_NAME || 'sales-26'}:${key}`;

// Tenant Companies
export const tenantCompaniesByLang = (lang) => {
    return tenant()?.companies?.map( company => { 
            return {
                companyId:company._id ,
                companyName: arrayNameByLang(company.name,lang)
            }
        });
}
export const BranchesByCompanyId = (companyId) => tenant()?.companies?.filter( (company) => company._id === companyId)[0]?.branches;

export const getCompanyById = (id) => tenant()?.companies?.filter(company => company._id === id)[0]


// Language Text Object
export const arrayNameByLang = (arrayName,lang) => {
    return  arrayName && arrayName.filter( name => name.lang === lang)[0] ;
}
export const langObjType = () =>{
    return languagesCode().reduce((k,v)=> ({...k,[v]:''}),{})
}
export const objLangTextHandler = (textObj) =>{
    let textHandler = [];
    for( const [key,value] of Object.entries(textObj)){
        textHandler.push( {
            text : value ,
            lang : key
        })
    }
    return textHandler
}

// Responsibles: the API stores `name` as [{text, lang}] (like fullname), the form edits it as {ar, en}.
const responsibleNameToObj = (name) => {
    if (Array.isArray(name)) return { ...langObjType(), ...LangArrayToObjKeyValue(name.filter((item) => item && item.lang)) };
    if (name && typeof name === 'object') {
        const { _id, ...byLang } = name;
        return { ...langObjType(), ...byLang };
    }
    return langObjType();
}
export const responsiblesFromApi = (list) => (Array.isArray(list) ? list : [])
    .filter((item) => item && typeof item === 'object')
    .map((item) => ({ ...item, name: responsibleNameToObj(item.name) }));
export const responsiblesToPayload = (list) => (Array.isArray(list) ? list : [])
    .map(({ name, ...item }) => ({
        ...item,
        name: objLangTextHandler(responsibleNameToObj(name)).filter((entry) => String(entry.text ?? '').trim() !== ''),
    }));

// General Settings
export const getGeneralSettings =  (settingName) => generlSettings()?.filter(setting => setting.name === settingName)[0]?.value 
export const defaultLang = getGeneralSettings('DEFAULT_LANG') || 'en';

// Invoice App Settings
export const invoiceAppSettings = () => AppSettings()?.filter(setting => setting?.app?.name === 'Invoices')[0];
export const getValueInvoiceAppSettings = (optionName) => invoiceAppSettings()?.setting?.filter(item => item.name === optionName)[0]?.value

export const printableDiv = (divPrintRef,direction='rtl') => {
    const sourceHtml = divPrintRef.current?.innerHTML || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sourceHtml;
    const hideOnPrintElements = tempDiv.querySelectorAll('[data-hide-on-print="true"]');
    hideOnPrintElements.forEach((element) => element.remove());
    const content = tempDiv.innerHTML;
    const dir = direction;;
    const printWindow = window.open('', '_blank');
    const printStyles = '<style>@media print{[data-hide-on-print="true"]{display:none !important;}}</style>';
    printWindow.document.write('<html><head>'+document.head.innerHTML+printStyles+'</head><body dir="'+ dir + '" style="padding:5px;" >' + content + '</body></html>');
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
        printWindow.document.close();
    }, 1000);
    // printWindow.onafterprint = function() {    
    // };
}

const stripMarkup = (value) => String(value || '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&[a-zA-Z0-9#]+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const hasMeaningfulEditorBlocks = (data) => {
    if (!data?.blocks || !Array.isArray(data.blocks)) return false;
    return data.blocks.some((block) => {
        if (!block) return false;
        if (block.type === 'delimiter') return true;
        const blockData = block.data;
        if (typeof blockData === 'string') {
            return stripMarkup(blockData) !== '';
        }
        if (Array.isArray(blockData?.items)) {
            return blockData.items.some((item) => {
                if (typeof item === 'string') return stripMarkup(item) !== '';
                if (item && typeof item === 'object') {
                    return stripMarkup(item.content || item.text || item.label || '') !== '';
                }
                return false;
            });
        }
        if (Array.isArray(blockData)) {
            return blockData.some((item) => stripMarkup(item) !== '');
        }
        if (blockData && typeof blockData === 'object') {
            return Object.values(blockData).some((item) => {
                if (typeof item === 'string') return stripMarkup(item) !== '';
                if (Array.isArray(item)) {
                    return item.some((subItem) => stripMarkup(typeof subItem === 'string' ? subItem : subItem?.content || subItem?.text || '') !== '');
                }
                return false;
            });
        }
        return false;
    });
};

export const parsePrintableContent = (value) => {
    if (value == null) {
        return { type: 'empty', blocks: null, html: '', text: '' };
    }

    if (typeof value === 'object') {
        if (hasMeaningfulEditorBlocks(value)) {
            return { type: 'blocks', blocks: value, html: '', text: '' };
        }
        return { type: 'empty', blocks: null, html: '', text: '' };
    }

    let current = String(value).trim();
    if (!current) {
        return { type: 'empty', blocks: null, html: '', text: '' };
    }

    for (let attempt = 0; attempt < 3; attempt += 1) {
        if (!current) break;
        try {
            const parsed = JSON.parse(current);
            if (typeof parsed === 'string') {
                current = parsed.trim();
                continue;
            }
            if (hasMeaningfulEditorBlocks(parsed)) {
                return { type: 'blocks', blocks: parsed, html: '', text: '' };
            }
            if (parsed?.blocks && Array.isArray(parsed.blocks)) {
                return { type: 'empty', blocks: null, html: '', text: '' };
            }
            break;
        } catch {
            break;
        }
    }

    current = current
        .replace(/^"+|"+$/g, '')
        .replace(/\\"/g, '"')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '')
        .replace(/""/g, '')
        .trim();

    const plainText = stripMarkup(current).replace(/\\/g, '').trim();
    if (!plainText || plainText === '"' || plainText === "''") {
        return { type: 'empty', blocks: null, html: '', text: '' };
    }

    return {
        type: 'html',
        blocks: null,
        html: current.replace(/\n/g, '<br/>'),
        text: plainText
    };
};

export const getDateNow = () => {
    var d = new Date();
    var local = d.getTime();
    var offset = d.getTimezoneOffset() * (60 * 1000);
    var utc = new Date(local + offset);
    var riyadh = new Date(utc.getTime() + (3 * 60 * 60 * 1000));
    return riyadh;
}
